"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const SelectOptionsToJSX_1 = require("./SelectOptionsToJSX");
const form_1 = require("../../atoms/form");
exports.default = ({ availableWeeks, weekTranslation, selectsValues, onChangeLeftCompareSelect, onChangeRightCompareSelect }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(form_1.Select, { value: selectsValues.left, onChange: onChangeLeftCompareSelect, children: availableWeeks.map((0, SelectOptionsToJSX_1.optionToJSX)(weekTranslation)) }, void 0), (0, jsx_runtime_1.jsx)(form_1.Select, { value: selectsValues.right, onChange: onChangeRightCompareSelect, children: availableWeeks.map((0, SelectOptionsToJSX_1.optionToJSX)(weekTranslation)) }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacings.m};

  & > div {
    width: 7.5rem;
  }

  select {
    color: ${({ theme }) => theme.colors.greyBase};
    text-transform: capitalize;
  }
`;
//# sourceMappingURL=CompareSelectGroup.js.map